import "./sidebar.scss";

import { FunctionComponent } from "react";
import {
    ChartCandlestick, DoorOpen, Users2, PiggyBankIcon, Cable, HandCoinsIcon,
    HomeIcon, UserRoundPlusIcon, ChevronRightIcon, Gavel, Hotel, CoinsIcon,
    ShoppingCartIcon, FileSpreadsheet, ArrowDownCircle, Scale, BanknoteArrowUp,
    BarChart3, Landmark, ArrowLeftRight, Send,
} from "lucide-react";
import { LucideIcon } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../features/helpers";
import { setSidebarStatus } from "../../store/SidebarSlice";
import { Link, useNavigate } from "react-router-dom";
import { setLoggedStatus, setLoggedType } from "../../store/AuthSlice";
import { clearSession } from "../../utils/session";

import { RouteKey } from "../../auth/permissions";
import { useRole } from "../../auth/useRole";

interface MenuItem {
    label: string;
    icon: LucideIcon;
    to: string;
    requireKey: RouteKey;
}

interface MenuGroup {
    title: string;
    items: MenuItem[];
}

const MENU: MenuGroup[] = [
    {
        title: "Geral",
        items: [
            { label: "Home",     icon: HomeIcon,         to: "/",           requireKey: "home" },
            { label: "Cotacao",  icon: ChartCandlestick, to: "/quotations", requireKey: "quotations" },
        ],
    },
    {
        title: "Acoes para Clientes",
        items: [
            { label: "Clientes",    icon: Users2,           to: "/clients",   requireKey: "clients" },
            { label: "Swaps",       icon: ShoppingCartIcon, to: "/purchases", requireKey: "purchases" },
            { label: "Envios",      icon: Send,             to: "/envios",    requireKey: "envios" },
            { label: "Creditos",    icon: HandCoinsIcon,    to: "/credits",   requireKey: "credits" },
        ],
    },
    {
        title: "Acoes para Fornecedores",
        items: [
            { label: "Fornecedores", icon: Cable,          to: "/suppliers", requireKey: "suppliers" },
            { label: "Repasses",     icon: ArrowLeftRight, to: "/repasses",  requireKey: "repasses" },
        ],
    },
    {
        title: "Acoes Internas",
        items: [
            { label: "Caixa",       icon: PiggyBankIcon,   to: "/profit",      requireKey: "profit" },
            { label: "Saldo",       icon: Scale,           to: "/balance",     requireKey: "balance" },
            { label: "Assets",      icon: CoinsIcon,       to: "/assets",      requireKey: "assets" },
            { label: "Nota Fiscal", icon: FileSpreadsheet, to: "/nota-fiscal", requireKey: "receipts" },
            { label: "Compliance",  icon: Gavel,           to: "/kyt",         requireKey: "compliance" },
            { label: "Contas Deposito", icon: Landmark,    to: "/deposit-accounts", requireKey: "deposit-accounts" },
        ],
    },
    {
        title: "Administracao",
        items: [
            { label: "Usuarios",     icon: UserRoundPlusIcon, to: "/users",              requireKey: "admin-users" },
            { label: "Organizacoes", icon: Hotel,             to: "/organizations",      requireKey: "admin-organizations" },
            { label: "Resumo",       icon: BarChart3,         to: "/companies-overview", requireKey: "admin-companies" },
        ],
    },
];

const AdminSidebar: FunctionComponent = () => {

    const dispatch  = useAppDispatch();
    const navigate  = useNavigate();
    const statusBar = useAppSelector((state) => state.sidebar.sidebarStatus);
    const { can }   = useRole();

    const openMenu = () => dispatch(setSidebarStatus(!statusBar));

    const logout = () => {
        dispatch(setLoggedStatus(false));
        dispatch(setLoggedType(""));
        clearSession();
        navigate("/");
    };

    // Filtra cada grupo pela matriz RBAC; grupos vazios somem inteiros.
    const visibleGroups = MENU
        .map((g) => ({ ...g, items: g.items.filter((i) => can(i.requireKey)) }))
        .filter((g) => g.items.length > 0);

    const hideOrShowMenu = () => {
        if (window.innerWidth < 768) {
            dispatch(setSidebarStatus(false))
        }
    }

    return (
        <div className={`sidebar-wrapper ${statusBar ? "active" : ""}`}>

            <h1 onClick={openMenu}>
                Menu <ChevronRightIcon size={20} />
            </h1>

            <div className="list">
                {visibleGroups.map((group) => (
                    <div className="menu-group" key={group.title}>
                        <span className="group-label">{group.title}</span>
                        <ul>
                            {group.items.map((item) => {
                                const Icon = item.icon;
                                return (
                                    <li key={item.to}>
                                        <Link to={item.to} onClick={hideOrShowMenu}>
                                            <Icon size={20} /> {item.label}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </div>

            <p className="p-like-button" onClick={logout}>
                <DoorOpen size={20} /> <span>Sair</span>
            </p>

        </div>
    );
};

export default AdminSidebar;
